import RecommendationField from './component';
import { RecommendationFieldProps } from './types';

export type { RecommendationFieldProps };
export default RecommendationField;
